var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M505.999 248.5c0 139.34-109.168 242.497-250 242.497-25.292 0-49.56-3.334-72.37-9.605a19.941 19.941 0 00-13.35.972l-49.624 21.907c-12.977 5.735-27.628-3.499-28.063-17.682l-1.364-44.477c-.17-5.475-2.634-10.603-6.72-14.247C35.865 384.361 6 321.388 6 248.5 6 109.165 115.168 6.002 256 6.002c140.831 0 249.999 103.163 249.999 242.498z",
    fill: "#0866ff",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.88 318.306l87.04-134.517c8.752-13.52-7.458-29.257-20.714-20.113l-90.86 62.67a9.19 9.19 0 01-10.218.152l-80.643-52.175c-6.826-4.414-15.94-2.463-20.353 4.363L101.085 313.21c-8.752 13.52 7.459 29.257 20.713 20.112l90.88-62.675a9.199 9.199 0 0110.224-.152l80.63 52.174c6.827 4.415 15.94 2.464 20.354-4.363h-.006z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger);
export default __webpack_public_path__ + "static/media/facebook-messenger.107ef7d9342650e514d928d0e04031d0.svg";
export { ForwardRef as ReactComponent };